export const GET_CAT_VALUE_DETAILS_API_REQUEST = 'GET_CAT_VALUE_DETAILS_API_REQUEST';
export const GET_CAT_VALUE_DETAILS_API_SUCCESS = 'GET_CAT_VALUE_DETAILS_API_SUCCESS';
export const GET_CAT_VALUE_DETAILS_API_ERROR = 'GET_CAT_VALUE_DETAILS_API_ERROR';

export const ADD_CAT_VALUE_DETAILS_API_REQUEST = 'ADD_CAT_VALUE_DETAILS_API_REQUEST';
export const ADD_CAT_VALUE_DETAILS_API_SUCCESS = 'ADD_CAT_VALUE_DETAILS_API_SUCCESS';
export const ADD_CAT_VALUE_DETAILS_API_ERROR = 'ADD_CAT_VALUE_DETAILS_API_ERROR';

export const UPDATE_CAT_VALUE_DETAILS_API_REQUEST = 'UPDATE_CAT_VALUE_DETAILS_API_REQUEST';
export const UPDATE_CAT_VALUE_DETAILS_API_SUCCESS = 'UPDATE_CAT_VALUE_DETAILS_API_SUCCESS';
export const UPDATE_CAT_VALUE_DETAILS_API_ERROR = 'UPDATE_CAT_VALUE_DETAILS_API_ERROR';